const services = () => {
  document.addEventListener("DOMContentLoaded", function () {

    const blocks = document.querySelectorAll(".services__section ");
    if (blocks.length > 0) {
      blocks.forEach((block) => {
        // Items Height
        const items = block.querySelectorAll(".services__item");
        if (items.length > 0) {
          let maxHeight = 0;
          items.forEach(item => {
            maxHeight = Math.max(maxHeight, item.offsetHeight);
          });
          items.forEach(item => {
            item.style.minHeight = `${maxHeight + 30}px`;
          })
        }

        const buttons = block.querySelectorAll(".more__btn");
        const header = document.querySelector(".header");
    
        buttons.forEach((button) => {
          button.addEventListener("click", function () {
            const labelOpen = button.getAttribute("data-label-open");
            const labelClose = button.getAttribute("data-label-close");
            let moreText = this.previousElementSibling;
            let isVisible = moreText.classList.contains("visible");
    
            // Close all other open tabs
            buttons.forEach((btn) => {
              btn.previousElementSibling.classList.remove("visible");
              btn.textContent = labelClose;
            });
    
            // Toggle the clicked tab
            if (!isVisible) {
              moreText.classList.add("visible");
              this.textContent = labelOpen;
              // Scroll to the tab with offset for header
              let tabPosition = this.closest(".services__item").getBoundingClientRect().top + window.scrollY;
              let headerOffset = header ? header.offsetHeight : 0;
              window.scrollTo({ top: tabPosition - headerOffset, behavior: "smooth" });
            } else {
              this.textContent = labelClose;
            }
          });
        });
      })
    }

  });
};

export default services;
